/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseNavigationMenuFragment} from '@amblique/contentful/app/contentful/fragments/navigation-menu/base-navigation-menu.fragment';
import {LinkFragment} from '@amblique/contentful/app/contentful/fragments/link/link.fragment';
import {MenuItemFragment} from '@amblique/contentful/app/contentful/fragments/menu-item/menu-item.fragment';
import {NavigationMenuPrimaryItemFragment} from '@amblique/contentful/app/contentful/fragments/navigation-menu-primary-item/navigation-menu-primary-item.fragment';

export const FullNavigationMenuFragment = gql`
  ${BaseNavigationMenuFragment}
  ${LinkFragment}
  ${MenuItemFragment}
  ${NavigationMenuPrimaryItemFragment}

  fragment FullNavigationMenuFragment on NavigationMenu {
    ...BaseNavigationMenuFragment

    menuItemsCollection {
      items {
        __typename
        ... on MenuItem {
          ...MenuItemFragment
        }
      }
    }
    menuItemsCursorCollection {
      items {
        __typename
        ... on MenuItem {
          ...MenuItemFragment
        }
      }
    }
    primaryItemsCollection {
      items {
        __typename
        ... on NavigationMenuPrimaryItem {
          ...NavigationMenuPrimaryItemFragment
        }
      }
    }
    primaryItemsCursorCollection {
      items {
        __typename
        ... on NavigationMenuPrimaryItem {
          ...NavigationMenuPrimaryItemFragment
        }
      }
    }
    promotionalLinksCollection {
      items {
        __typename
        ... on Link {
          ...LinkFragment
        }
      }
    }
    promotionalLinksCursorCollection {
      items {
        __typename
        ... on Link {
          ...LinkFragment
        }
      }
    }
  }
`;
